import React from "react";

/**
 * Renders a female icon SVG element with the provided class name.
 *
 * @param {object} cls - The class name for styling the SVG element
 * @return {JSX.Element} The rendered female icon SVG element
 */
export const FemaleIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <g clipPath="url(#clip0_1824_57607)">
        <path
          d="M20 8.49991C20.0012 6.96007 19.558 5.45259 18.7235 4.15844C17.8891 2.86429 16.6989 1.83846 15.2958 1.20409C13.8927 0.569712 12.3363 0.353754 10.8135 0.582134C9.29067 0.810515 7.86613 1.47353 6.71084 2.49159C5.55556 3.50965 4.71864 4.83949 4.30054 6.32149C3.88244 7.80349 3.90093 9.37466 4.35379 10.8464C4.80665 12.3182 5.67463 13.6279 6.85355 14.6185C8.03247 15.6091 9.47223 16.2384 11 16.4309V19.4999H9C8.73478 19.4999 8.48043 19.6053 8.29289 19.7928C8.10535 19.9803 8 20.2347 8 20.4999C8 20.7651 8.10535 21.0195 8.29289 21.207C8.48043 21.3946 8.73478 21.4999 9 21.4999H11V23.4999C11 23.7651 11.1054 24.0195 11.2929 24.207C11.4804 24.3946 11.7348 24.4999 12 24.4999C12.2652 24.4999 12.5196 24.3946 12.7071 24.207C12.8946 24.0195 13 23.7651 13 23.4999V21.4999H15C15.2652 21.4999 15.5196 21.3946 15.7071 21.207C15.8946 21.0195 16 20.7651 16 20.4999C16 20.2347 15.8946 19.9803 15.7071 19.7928C15.5196 19.6053 15.2652 19.4999 15 19.4999H13V16.4309C14.9315 16.1858 16.7076 15.2455 17.9959 13.7857C19.2843 12.326 19.9968 10.4469 20 8.49991ZM6 8.49991C6 7.31322 6.35189 6.15319 7.01118 5.16649C7.67047 4.1798 8.60754 3.41076 9.7039 2.95663C10.8003 2.50251 12.0067 2.38369 13.1705 2.6152C14.3344 2.84671 15.4035 3.41816 16.2426 4.25727C17.0818 5.09639 17.6532 6.16548 17.8847 7.32937C18.1162 8.49326 17.9974 9.69966 17.5433 10.796C17.0891 11.8924 16.3201 12.8294 15.3334 13.4887C14.3467 14.148 13.1867 14.4999 12 14.4999C10.4092 14.4983 8.88399 13.8657 7.75911 12.7408C6.63424 11.6159 6.00159 10.0907 6 8.49991Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1824_57607">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
